import { render, staticRenderFns } from "./BannerUpgrade.vue?vue&type=template&id=24f66abd&scoped=true&"
import script from "./BannerUpgrade.vue?vue&type=script&lang=js&"
export * from "./BannerUpgrade.vue?vue&type=script&lang=js&"
import style0 from "./BannerUpgrade.vue?vue&type=style&index=0&id=24f66abd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24f66abd",
  null
  
)

export default component.exports